/* Komodin mağaza sayfası (tema sahibi kod): sekmeler (?tab=, replaceState), sıralama (masaüstü açılır kutu + mobil tam ekran),
   mobil filtre sayfası, filtre akordiyonu, sonsuz ızgara. Ürünler /collections/<handle>?section_id=kt-store-grid ile gelir. */
(function () {
  'use strict';
  var d = document, w = window;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  function init() {
    var root = qs('[data-kt-store]'); if (!root) return;
    var col = root.getAttribute('data-collection') || 'all';
    /* alt mağaza: kategori koleksiyonu stok dışı ürünleri de içerir → ızgara vitrin stok filtresiyle gelir (kt-store.liquid data-stok) */
    var stok = root.getAttribute('data-stok') === '1';
    var sort = 'manual', page = 1, pages = 1, busy = false, io = null;
    var KT = w.KT || {};

    function setTab(name, push) {
      qsa('[data-kt-store-tab]', root).forEach(function (b) {
        var on = b.getAttribute('data-kt-store-tab') === name;
        b.classList.toggle('text-themeDefaultColor', on); b.classList.toggle('text-gray-600', !on);
        if (b.classList.contains('text-base')) b.classList.toggle('hover:text-themeDefaultColor', !on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var bar = qs('[data-kt-tab-bar]', b); if (bar) bar.classList.toggle('kt-gizli', !on);
      });
      if (push) { try { var u = new URL(location.href); if (name === 'ana-sayfa') u.searchParams.delete('tab'); else u.searchParams.set('tab', name); history.replaceState(null, '', u.toString()); } catch (e) {} }
    }
    var t0 = new URL(location.href).searchParams.get('tab'); if (t0 === 'tum-urunler') setTab('tum-urunler', false);

    function grid() { return qs('[data-kt-store-grid]', root); }
    function readPages(g) { page = Number(g.getAttribute('data-page')) || 1; pages = Number(g.getAttribute('data-pages')) || 1; }
    readPages(grid());

    function fetchPage(p) {
      var u = '/collections/' + encodeURIComponent(col) + '?section_id=kt-store-grid&page=' + p + (sort && sort !== 'manual' ? '&sort_by=' + encodeURIComponent(sort) : '') + (stok ? '&filter.v.availability=1' : '');
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html; return qs('[data-kt-store-grid]', tmp);
      });
    }
    function setSort(val, label) {
      sort = val;
      qsa('[data-kt-sort-label]', root).forEach(function (s) { s.textContent = label; });
      qsa('[data-kt-store-sort]', root).forEach(function (b) {
        var on = b.getAttribute('data-kt-store-sort') === val, inPage = !!b.closest('[data-kt-store-page]');
        b.setAttribute(inPage ? 'aria-pressed' : 'aria-selected', on ? 'true' : 'false');
        if (inPage) {
          ['border-themeDefaultColor', 'bg-neutral-100', 'text-themeDefaultColor'].forEach(function (c) { b.classList.toggle(c, on); });
          ['border-gray-200', 'bg-white', 'text-gray-800', 'hover:border-neutral-300', 'hover:bg-neutral-50'].forEach(function (c) { b.classList.toggle(c, !on); });
        } else {
          ['bg-neutral-100', 'font-semibold'].forEach(function (c) { b.classList.toggle(c, on); });
          b.classList.toggle('hover:bg-gray-50', !on);
        }
      });
      var g = grid(); if (g) g.classList.add('opacity-60');
      fetchPage(1).then(function (ng) { if (ng && g) { g.replaceWith(ng); readPages(ng); if (KT.markFavs) KT.markFavs(); } else if (g) g.classList.remove('opacity-60'); })
        .catch(function () { if (g) g.classList.remove('opacity-60'); });
    }
    function openPage(name, on) {
      var pg = qs('[data-kt-store-page="' + name + '"]', root); if (!pg) return;
      pg.classList.toggle('kt-gizli', !on);
      if (KT.lock && KT.unlock) { if (on) KT.lock(); else KT.unlock(); }
    }
    function menu(on) {
      var m = qs('[data-kt-store-sort-menu]', root), t = qs('[data-kt-store-sort-trigger]', root); if (!m || !t) return;
      m.classList.toggle('kt-gizli', !on); t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var tab = t.closest && t.closest('[data-kt-store-tab]'); if (tab) { e.preventDefault(); setTab(tab.getAttribute('data-kt-store-tab'), true); return; }
      if (t.closest('[data-kt-store-sort-trigger]')) { e.preventDefault(); var m = qs('[data-kt-store-sort-menu]', root); menu(m.classList.contains('kt-gizli')); return; }
      var so = t.closest('[data-kt-store-sort]');
      if (so) { e.preventDefault(); menu(false); var pg = so.closest('[data-kt-store-page]'); if (pg) openPage(pg.getAttribute('data-kt-store-page'), false); setSort(so.getAttribute('data-kt-store-sort'), so.getAttribute('data-label')); return; }
      var op = t.closest('[data-kt-store-open]'); if (op) { e.preventDefault(); openPage(op.getAttribute('data-kt-store-open'), true); return; }
      var cl = t.closest('[data-kt-store-close]'); if (cl) { e.preventDefault(); var p2 = cl.closest('[data-kt-store-page]'); if (p2) openPage(p2.getAttribute('data-kt-store-page'), false); return; }
      var grp = t.closest('[data-kt-filter-group]');
      if (grp) {
        e.preventDefault();
        var wrap = grp.closest('[data-kt-filter-wrap]'), panel = wrap && qs('[data-kt-filter-panel]', wrap), open = grp.getAttribute('aria-expanded') === 'true';
        grp.setAttribute('aria-expanded', open ? 'false' : 'true'); if (panel) panel.hidden = open;
        return;
      }
    });
    d.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('[data-kt-sort-wrap]')) menu(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { menu(false); openPage('sort', false); openPage('filter', false); } });

    /* sonsuz ızgara */
    var sentinel = qs('[data-kt-feed-sentinel]', root), status = qs('[data-kt-feed-status]', root);
    function more() {
      if (busy || page >= pages) return; busy = true;
      if (status) { status.hidden = false; qs('[data-kt-feed-loading]', status).hidden = false; qs('[data-kt-feed-retry]', status).hidden = true; }
      fetchPage(page + 1).then(function (ng) {
        var g = grid(); if (ng && g) { while (ng.firstElementChild) g.appendChild(ng.firstElementChild); page++; }
        busy = false; if (status) status.hidden = true; if (KT.markFavs) KT.markFavs();
      }).catch(function () { busy = false; if (status) { status.hidden = false; qs('[data-kt-feed-loading]', status).hidden = true; qs('[data-kt-feed-retry]', status).hidden = false; } });
    }
    if (status) { var rb = qs('[data-kt-feed-retry]', status); if (rb) rb.addEventListener('click', more); }
    if (sentinel && 'IntersectionObserver' in w) { io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) more(); }); }, { rootMargin: '500px 0px' }); io.observe(sentinel); }

    /* alt mağaza: ilk sayfa da stok filtresiyle gelir (sunucu çiziminde stok dışılar atlandı); sayfa ve ürün sayısı filtreli sonuçtan */
    if (stok) {
      busy = true;
      fetchPage(1).then(function (ng) {
        var g = grid();
        if (ng && g) {
          g.replaceWith(ng); readPages(ng); if (KT.markFavs) KT.markFavs();
          var n = Number(ng.getAttribute('data-count'));
          if (n >= 0) qsa('[data-kt-store-count]', root).forEach(function (e) { e.textContent = '(' + (n > 25000 ? '25.000+' : n.toLocaleString('tr-TR')) + ' Ürün)'; });
        }
        busy = false;
      }).catch(function () { busy = false; });
    }
  }

  if (w.KT && w.KT.register) w.KT.register(init);
  else if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
